import c from "../../utils/constants";

class BotFlowController {
  constructor(BotFlowService, MermaidService,$scope, $q) {
    "ngInject"

    this.botFlowService = BotFlowService;
    this.mermaidService = MermaidService;
    this.$scope = $scope;
    this.$q = $q;
  }

  $onInit() {

    this.mermaidService.init();

    this.isLoading = true;

    const botFlowsPromise = this.botFlowService.getBotFlowsPromise();

    this.$q.all([botFlowsPromise]).then(data => {

      const [botsFlowsResponse] = data;

      this.isLoading = false;

      this.initializeFlows(botsFlowsResponse);
    });    
  } 

  initializeFlows(flowGroups) {
    let items = [];
    flowGroups.data.forEach(flowGroup => {
      let childItems = [];
      flowGroup.botFlows.forEach(botFlow => {
        childItems.push({
          id: botFlow.id,
          text: botFlow.title,
          flowChart: botFlow.flowChart
        });
      });

      items.push({
        text: flowGroup.title,
        expanded: true,
        items: childItems
      });
    });

  this.treeViewOptions = {
      dataSource: [{
        text: "Bot Flows",
        expanded: true,
        items: items
      }],
      select: (e) => this.onTreeViewSelect(e),
    }        
  } 

  onTreeViewSelect(e) {
    let treeview = $("#bot-flow-tree-view").data("kendoTreeView");
    let dataItem = treeview.dataItem(e.node);

    if(dataItem.id)
      this.renderGraph(dataItem);
  }  

  renderGraph(dataItem) {
    this.setHeader(dataItem.text);
    let id = dataItem.id;
    let graphData = dataItem.flowChart;

    this.mermaidService.render(`graph-${id}`, graphData, (svg, bindingFunctions)=> {
      document.getElementById("bot-flow-graph").innerHTML = svg;
    });
  }    

  setHeader(header) {
    setTimeout(() => {
      this.header = header;
      this.$scope.$apply();
    }, 0);
  }  

}

export default BotFlowController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/bot-flow/bot-flow.controller.js
 **/